import type { MemberPublic } from '@/lib/db/types';

interface Props {
  members: MemberPublic[];
  currentMemberId: string;
  transferTo: string;
  onTransferToChange: (id: string) => void;
  onTransfer: () => void;
  onDelete: () => void;
  deleteLabel?: string;
  transferBusy?: boolean;
  deleteBusy?: boolean;
}

export function OrganizerActions({
  members,
  currentMemberId,
  transferTo,
  onTransferToChange,
  onTransfer,
  onDelete,
  deleteLabel = 'Delete',
  transferBusy,
  deleteBusy,
}: Props) {
  const candidates = members.filter((m) => m.id !== currentMemberId);

  return (
    <div className="space-y-3 rounded-xl border border-line bg-paper p-3">
      <div className="text-xs font-bold uppercase tracking-wider text-slate-400">Organizer</div>
      <div>
        <label className="mb-1 block text-xs font-semibold text-slate-500">Transfer ownership</label>
        <select
          value={transferTo}
          onChange={(e) => onTransferToChange(e.target.value)}
          className="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm"
        >
          <option value="">Select member…</option>
          {candidates.map((m) => (
            <option key={m.id} value={m.id}>{m.name}</option>
          ))}
        </select>
        <button
          type="button"
          disabled={!transferTo || transferBusy}
          onClick={onTransfer}
          className="mt-2 w-full rounded-full border border-navy py-2.5 text-sm font-semibold text-navy disabled:opacity-50"
        >
          {transferBusy ? 'Transferring…' : 'Transfer Ownership'}
        </button>
      </div>
      <button
        type="button"
        disabled={deleteBusy}
        onClick={onDelete}
        className="w-full rounded-full bg-red-50 py-2.5 text-sm font-bold text-red-700 disabled:opacity-50"
      >
        {deleteBusy ? 'Removing…' : deleteLabel}
      </button>
    </div>
  );
}
